import _typeof from "@babel/runtime/helpers/esm/typeof";
export var isObject = function isObject(val) {
  return _typeof(val) === 'object' && val !== null && !Array.isArray(val);
};